import { render, staticRenderFns } from "./SleepSection.vue?vue&type=template&id=0a2c52b8&"
import script from "./SleepSection.vue?vue&type=script&lang=js&"
export * from "./SleepSection.vue?vue&type=script&lang=js&"
import style0 from "./SleepSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports